import { Suspense, useEffect, useState } from 'react'
import { Footer } from '@pmndrs/branding'
import { useStore } from '../utils/store'

function Ready({ setReady }) {
  useEffect(() => () => void setReady(true), [])
  return null
}

export function Overlay({ children }) {
  const [ready, setReady] = useState(false)
  const [clicked, setClicked] = useState(false)
  const set = useStore((state) => state.set)

  useEffect(() => {
    if (clicked && ready) set({ ready: true })
  }, [ready, clicked])

  const goHandsfree = () => {
    handsfree.start(() => {
      ready && setClicked(true)
    })
  }
  
  return (
    <>
      <Suspense fallback={<Ready setReady={setReady} />}>{children}</Suspense>
      <div className={`fullscreen bg ${ready ? 'ready' : 'notready'} ${clicked && 'clicked'}`}>
        <div className="text-center">
          <div onClick={() => ready && setClicked(true)}>{!ready ? 'loading' : 'click to here to continue with keyboard'}</div>
          <p>~ or ~</p>
          <p>
            <button onClick={() => goHandsfree()} id="handsfree-button" className="handsfree-button handsfree-show-when-stopped handsfree-hide-when-loading">Go Handsfree</button>
            <button class="handsfree-button handsfree-show-when-loading">...loading...</button>
          </p>
          <p>
            <table>
              <tr>
                <td><strong>Hand</strong></td>
                <td><strong>Pose</strong></td>
                <td><strong>Action</strong></td>
              </tr>
              <tr>
                <td>Right</td>
                <td>✊</td>
                <td>Accelerate</td>
              </tr>
              <tr>
                <td>Right</td>
                <td>🤚</td>
                <td>Stop/Reverse</td>
              </tr>
              <tr>
                <td>Left</td>
                <td>👍</td>
                <td>Turn Left</td>
              </tr>
              <tr>
                <td>Left</td>
                <td>👎</td>
                <td>Turn Right</td>
              </tr>
            </table>
          </p>
        </div>
        <Footer
          date="2. June"
          year="2021"
          link1={<a href="https://github.com/pmndrs/react-three-fiber">@react-three/fiber</a>}
          link2={<a href="https://github.com/pmndrs/racing-game">/racing-game</a>}
        />
      </div>
    </>
  )
}
